import { WizardService } from "../../../services/wizard/wizard.service";
import { TripSemantics } from "../../create-rule/define-duty/define-duty.component";
import { getPayloadCommon } from "./define-duty-common.payload";

export function getPayload(wizardService: WizardService) {
	return getPayloadCommon(wizardService, TripSemantics.tripStart);
}
